import { render, staticRenderFns } from "./ttshop_barteragree.vue?vue&type=template&id=5e7e55ff&scoped=true&"
import script from "./ttshop_barteragree.vue?vue&type=script&lang=js&"
export * from "./ttshop_barteragree.vue?vue&type=script&lang=js&"
import style0 from "./ttshop_barteragree.vue?vue&type=style&index=0&id=5e7e55ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7e55ff",
  null
  
)

export default component.exports